export default __webpack_public_path__ + "static/media/404.a5e42151.png";